var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page"},[_c('header',{staticClass:"section page-header"},[_c('CzMenu',{attrs:{"showBtnHeader":_vm.showBtnHeader}})],1),_vm._t("default"),_c('Footer')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }